<template>
  <div v-loading="loading" class="pull_extend_package">
    <el-form ref="formModel" inline :model="form_model" :rules="rules" label-width="160px">
      <!-- 投放账号以及应用 -->
      <el-form-item label="投放账号以及应用" required>
        <el-form-item prop="advertiser_id">
          <el-select
            v-model="form_model.advertiser_id"
            v-loading="advertiser.loading"
            placeholder="请选择广告投放账号"
            size="mini"
            filterable
            @change="changeAdvertiser"
          >
            <el-option
              v-for="advertiser_item in advertiser.response"
              :key="advertiser_item.id"
              :label="advertiser_item.note"
              :value="advertiser_item.id"
            >
              {{ advertiser_item.label }}
              <span style="color:darkgray">{{ advertiser_item.note }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="package_id">
          <!-- 应用id -->
          <el-select
            v-model="form_model.package_id"
            v-loading="app.loading"
            class="extension_select"
            placeholder="请选择应用"
            size="mini"
            filterable
          >
            <div class="app_title">
              <span style="float: left">应用名称</span>
              <span style="float: right">应用id</span>
            </div>
            <el-option
              v-for="(item, index) in app.response.list"
              :key="index"
              :label="item.name"
              :value="item.type_id"
            >
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right">{{ item.type_id }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="closePullDialog">取 消</el-button>
      <el-button :loading="submit_loading" size="mini" type="primary" @click="configPullDialog">同步渠道分包数据</el-button>
    </span>
  </div>
</template>
<script>
import PromotedObject from '@/api/tool/promoted-object/gdt';
const promotedObject = new PromotedObject();

import ExtendPackageResource from '@/api/tool/extend-package/gdt';
const extendPackageResource = new ExtendPackageResource();

import ConfigResource from '@/api/config';
const configResource = new ConfigResource();

export default {
  data() {
    return {
      submit_loading: false,
      /** 广告主ID */
      advertiser: {
        loading: false,
        params: {
          module: 'ad',
          key: 'gdt_pack_account',
        },
        response: [],
      },
      /** 应用ID */
      app: {
        loading: false,
        params: { is_list: 1, advertiser_id: '', promoted_object_type: 'PROMOTED_OBJECT_TYPE_APP_ANDROID' },
        response: { list: [] },
      },
      loading: false,
      form_model: {
        advertiser_id: '',
        package_id: null,
      },
      rules: {
        advertiser_id: [{ required: true, message: '请选择广告主', trigger: ['blur', 'change'] }],
        package_id: [{ required: true, message: '请选择应用', trigger: ['blur', 'change'] }],
      },
    };
  },
  created() {
    /** 获取广告主 */
    this.getConfigList().then((response) => {
      this.advertiser.response = response;
    });
  },
  methods: {
    /** 获取广告配置列表 */
    getConfigList: function() {
      this.advertiser.loading = true;
      return new Promise((resolve, reject) => {
        configResource
          .getConfigDataApi(this.advertiser.params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => {
            this.advertiser.loading = false;
          });
      });
    },

    /** 获取应用列表 */
    getAppList() {
      this.app.loading = true;
      promotedObject
        .getPromotedObject(this.app.params)
        .then((response) => {
          this.app.response = response;
        }).finally(() => {
          this.app.loading = false;
        });
    },

    /** 切换广告主 */
    changeAdvertiser(val){
      this.form_model.package_id = null;
      this.form_model.advertiser_id = val;
      this.app.params.advertiser_id = val;
      this.getAppList();
    },

    /** 确定同步 */
    configPullDialog(){
      this.$refs['formModel'].validate((valid) => {
        if (valid) {
          this.submit_loading = true;
          extendPackageResource.pullExtendPackageApi({
            advertiser_id: this.form_model.advertiser_id,
            package_id: this.form_model.package_id,
          }).then((res) => {
            this.$message.success(res.message || '同步成功');
            this.$emit('config');
          }).finally(() => {
            this.submit_loading = false;
          });
        } else {
          return false;
        }
      });
    },

    /** 取消同步 */
    closePullDialog(){
      this.$emit('cancel');
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.items1 /deep/ .el-form-item__content {
  width: 100%;
}

.el-card /deep/ .el-card__header{
   padding: 2px 20px;
}
.input_class{
  width: 300px;
}
.dialog-footer{
  width: 100%;
  text-align: center;
  display: block;
}
.box-card {
  width: 300px;
}
.channels_tags{
  margin-left: 10px;
}

.extension_select{
  width: 350px;
}

.app_title{
  width: 100%;
  height: 23px;
  float: left;
  line-height: 22px;
  padding-left: 20px;
  border-bottom: 1px solid gray;
  padding-right: 20px;
  span{
    font-size: 14px;
    font-weight: 700;
  }
}
</style>
